import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './config/routes'
import store from './config/vuex/store'
import axios from 'axios'
import moment from 'vue-moment'
import timezone from 'moment-timezone'
import VueLoading from 'vuejs-loading-plugin'
import common from './config/mixin/common'

import validation from "@/config/mixin/validation"
import i18n from "@/config/i18n"
import "vue-snotify/styles/material.css"
import filters from '@/config/util/filter'
import Notify from "@/config/util/notify";
import constant from '@/config/const/const'
import VueCryptojs from "vue-cryptojs/src/index";

Vue.config.productionTip = false

Vue.use(moment)
Vue.use(VueLoading,{
  text:'In Progress',
  background: 'rgba(0, 0, 0, 0.2)',
  classes:['loading-circle-cus']
})
Vue.use(filters)
Vue.use(Notify)
Vue.use(VueCryptojs)

//global http use axios
Vue.prototype.$http = axios
Vue.prototype.$const = constant

Vue.mixin(common)
//before route enter call function

Vue.prototype.$eventBus = new Vue()

let vm = new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  created() {
    this.$store.dispatch(constant.ACTIONS.SET_CLIENT_CD)
    timezone.tz.setDefault('Asia/Jakarta')
  }
}).$mount('#app')


// axios.interceptors.request.use(function (config) {
//   vm.$loading(true)
//   return config
// }, function (error) {
//   vm.$loading(false)
//   return Promise.reject(error);
// });
//
// axios.interceptors.response.use(function (response) {
//   vm.$loading(false)
//   return response;
// }, function (error) {
//   vm.$loading(false)
//   return Promise.reject(error);
// });
